import { z } from "zod";
const AssetDeleteScheduleStatus = z.enum(["InProgress", "Pending"]);
export const AssetDeleteSchedule = z.object({
    id: z.string(),
    path: z.string(),
    createdAt: z.date(),
    deleteAt: z.date(),
    isFolder: z.boolean(),
    status: AssetDeleteScheduleStatus,
});
